import { type ReactNode, useState } from 'react'
import clsx from 'clsx'
import { ReactComponent as EditSvg } from '../../../assets/svgs/edit.svg'
import { ReactComponent as TrashSvg } from '../../../assets/svgs/secondary-trash.svg'
import { ReactComponent as SaveSvg } from '../../../assets/svgs/save.svg'

type Props = {
  header: ReactNode
  children: ReactNode
  handleRemove: () => void
  canRemove?: boolean
}

export const OpenInputEmail = ({
  header,
  children,
  handleRemove,
  canRemove,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggleIsOpen = () => {
    setIsOpen(true)
  }

  const handleToggleIsClose = () => {
    setIsOpen(false)
  }

  return (
    <div
      className={clsx('flex w-full gap-2', {
        'border-dashed border-y-1 border-grey-700 py-4': isOpen,
        'border-none border-y-0 py-0': !isOpen,
      })}
    >
      <div className="flex flex-col w-full gap-4">
        {header}

        {isOpen && <>{children}</>}
      </div>

      <div className="flex gap-2 mt-4">
        {isOpen ? (
          <SaveSvg
            className="scale-x-100 mt-1 cursor-pointer h-[22px] w-[22px] stroke-grey-700"
            onClick={handleToggleIsClose}
          />
        ) : (
          <EditSvg
            className="cursor-pointer h-7 w-7 stroke-grey-700"
            onClick={handleToggleIsOpen}
          />
        )}
        {canRemove && (
          <TrashSvg
            className="cursor-pointer h-7 w-7 stroke-grey-700"
            onClick={handleRemove}
          />
        )}
      </div>
    </div>
  )
}
